module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00225.59f2be98.jpg";